var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg15X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.9a1 1 0 0 0-1.854-.52l-.073.12c-.403.668-.842 1.394-2.087 2.141a1 1 0 0 0 1.029 1.716c.377-.227.703-.457.985-.686V16a1 1 0 1 0 2 0V7.9ZM11 7a1 1 0 0 0-.99.858l-.5 3.5a1 1 0 0 0 1.146 1.13l1.82-.287a1.534 1.534 0 1 1 .24 3.05h-.272c-.44 0-.865-.16-1.195-.452l-.338-.298A1 1 0 1 0 9.588 16l.338.298c.696.614 1.59.952 2.518.952h.271a3.534 3.534 0 1 0-.55-7.026l-.484.076L11.867 9h3.132a1 1 0 0 0 0-2h-4Zm7.707 5.293a1 1 0 1 0-1.414 1.415l.793.793-.793.793a1 1 0 0 0 1.414 1.414l.793-.793.793.793a1 1 0 1 0 1.414-1.414l-.793-.793.793-.793a1 1 0 0 0-1.414-1.415l-.793.793-.793-.793ZM8.5 16.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15X);
export default __webpack_public_path__ + "static/media/1.5x.d5d4852c8bdb3ea04a7ef81fd75d853f.svg";
export { ForwardRef as ReactComponent };